<template>
    <grid
        ref="properties-table"
        :is-auto-height="true"
        :is-search="false"
        :row-data="rowData"
        :column-defs="columnDefs"
        :headerHeight="40"
        :class="{ 'properties-table-invalid': rowData.length === 0 }"
        grid-theme="ag-theme-alpine-compact"
        overlayNoRowsTemplate="Please add a property"
    ></grid>
</template>

<script>
    import isNil from 'lodash/isNil';
    import Grid from '../../generic/grid/grid.vue';
    import ActionsCellRendererProperties from './reservation-details-actions-cell-renderer-properties.vue';
    import ActionsHeaderRendererAddProperty from './reservation-details-actions-header-renderer-add-property.vue';
    import AdultsHeaderRenderer from './reservation-details-properties-header-renderer-adults.vue';

    export default {
        name: 'PropertiesTable',
        components: {
            Grid,
            actionsCellRenderer: ActionsCellRendererProperties,
            actionsHeaderRendererAddProperty: ActionsHeaderRendererAddProperty,
            adultsHeaderRenderer: AdultsHeaderRenderer,
        },
        props: ['value'],
        inject: ['getAvailablePropertiesRequestData'],
        data() {
            return {
                gridValues: [],
                isEdit: false,
                columnDefs: [
                    {
                        headerName: '',
                        minWidth: 80,
                        maxWidth: 80,
                        flex: 0,
                        sortable: false,
                        resizable: false,
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            onRemoveProperty: this.handleRemoveProperty,
                        },
                        headerComponent: 'actionsHeaderRendererAddProperty',
                        headerComponentParams: {
                            getAvailablePropertiesRequestData: this.getAvailablePropertiesRequestData,
                        },
                    },
                    {
                        headerName: 'Property Name',
                        sortable: false,
                        field: 'name',
                        flex: 3,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        headerName: 'Adults',
                        sortable: false,
                        field: 'adults',
                        minWidth: 100,
                        maxWidth: 300,
                        flex: 1,
                        editable: true,
                        cellDataType: 'number',
                        cellEditorParams: ({ data }) => ({ isNumeric: true, select: true, min: 1 }),
                        editable: ({ data }) => !isNil(data.adults),
                        cellClass: ({ data }) => (!isNil(data.adults) ? 'text-primary lx-editable-cell' : ''),
                        valueSetter: ({ newValue, data, api }) => {
                            data.adults = parseInt(newValue) >= 1 ? parseInt(newValue) : 1;
                            this.gridValues = this.gridValues.map((item) => {
                                if (item.property_id === data.property_id) {
                                    item.adults = data.adults;
                                }
                                return item;
                            });
                            //if (data.adults > data.max_guests) {
                            //    data.adults = data.max_guests;
                            //}
                            return true;
                        },
                        headerComponent: 'adultsHeaderRenderer',
                        headerComponentParams: {},
                    },
                    {
                        headerName: 'Children',
                        sortable: false,
                        field: 'children',
                        minWidth: 100,
                        maxWidth: 300,
                        editable: true,
                        cellDataType: 'number',
                        flex: 1,
                        cellEditorParams: ({ data }) => ({ isNumeric: true, select: true, min: 0 }),
                        editable: ({ data }) => !isNil(data.children),
                        cellClass: ({ data }) => (!isNil(data.children) ? 'text-primary lx-editable-cell' : ''),
                        valueSetter: ({ newValue, data }) => {
                            data.children = parseInt(newValue) >= 0 ? parseInt(newValue) : 0;
                            this.gridValues = this.gridValues.map((item) => {
                                if (item.property_id === data.property_id) {
                                    item.children = data.children;
                                }
                                return item;
                            });
                            //if (data.children > data.max_guests) {
                            //    data.children = data.max_guests;
                            //}
                            return true;
                        },
                    },
                    //{
                    //    type: 'editableColumn',
                    //    headerName: 'Pets',
                    //    sortable: false,
                    //    field: 'pets',
                    //    flex: 1,
                    //    cellEditorParams: { isNumeric: true, select: true },
                    //    editable: ({ data }) => (!isNil(data.pets) && data.pets_allowed),
                    //    cellClass: ({ data }) => (!isNil(data.pets) && data.pets_allowed) ? 'text-primary lx-editable-cell' : '',
                    //    valueSetter: ({ newValue, data }) => {
                    //        data.pets = parseInt(newValue);
                    //        if (data.pets > data.max_pets) {
                    //            data.pets = data.max_pets;
                    //        }
                    //        return true;
                    //    },
                    //},
                    {
                        headerName: 'Pets',
                        sortable: false,
                        field: 'pets',
                        flex: 1,
                        minWidth: 100,
                        maxWidth: 300,
                    },
                ],
            };
        },
        mounted() {
            this.gridValues = this.value;
        },
        computed: {
            rowData() {
                return this.gridValues.map((item) => ({
                    ...item,
                    id: item.property_id?.toString(),
                }));
            },
        },
        methods: {
            handleRemoveProperty(index) {
                this.gridValues.splice(index, 1);
                this.successToast({ text: 'Property/Room sucessfully removed.' });
            },
        },
        watch: {
            value: {
                handler(newVal) {
                    this.gridValues = newVal;
                },
                deep: true,
            },
            gridValues: {
                handler(newValues) {
                    this.$emit('input', newValues);
                },
                deep: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.ag-theme-alpine-compact) {
        .ag-center-cols-clipper,
        .ag-center-cols-container,
        .ag-center-cols-viewport {
            min-height: 50px !important;
        }
    }

    :deep(.ag-root-wrapper) {
        border-radius: 5px;
        padding: 10px;
        padding-left: 0;
        padding-right: 0;
    }

    :deep(.ag-header) {
        border-bottom: solid 1px rgba(0, 0, 0, 0.1) !important;
    }

    :deep(.ag-row) {
        border: 0;
    }

    .lx-grid {
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.1);
    }

    .properties-table-invalid {
        border: 1px solid red;
    }
    :deep(.ag-header-cell) {
        font-size: 16px !important;
    }
    :deep(.ag-cell-value) {
        font-size: 16px !important;
    }
</style>
